
export class BadRequestError extends Error {
    constructor(message: string) {
        super('HTTP 400 Error:' + message);
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, BadRequestError.prototype);
    }
}
